import React from "react";
import SmartScanUpperLipPage from "../../components/SmartScanUpperLip/SmartScanUpperLipPage";
const SmartScanUpperLip = () => {
  return (
    <>
      <body className="mobile-body">
        <div className="body-content">
          <section className="review-photo-section py-4 py-md-5">
            <SmartScanUpperLipPage />
          </section>
        </div>
      </body>
    </>
  );
};

export default SmartScanUpperLip;
